var _path, _path2, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _path3, _rect5, _rect6, _polygon, _rect7, _path4, _rect8, _path5, _path6, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _path7, _path8, _path9, _path0, _path1, _path10, _rect9, _path11, _polygon2, _path12, _polygon3, _path13, _circle11, _path14, _path15, _path16, _path17, _path18, _path19, _ellipse, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawSendGiftJl1Z(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 836.79488,
    height: 447.54331,
    viewBox: "0 0 836.79488 447.54331",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.51663,672.62709l-.04859-.92865c-.01031-.20417-.916-20.56244,11.77923-34.102,12.69583-13.54026,34.48628-15.45558,34.70447-15.47323l.99524-.08088.04842.92827c.01031.20416.9158,20.56205-11.77923,34.102-12.69584,13.54025-34.48627,15.45558-34.70448,15.47322ZM227.632,638.72175c-10.734,11.44747-11.42218,27.96353-11.41679,32.09337,4.39669-.556,21.89283-3.4309,32.61629-14.86784,10.72222-11.43574,11.4189-27.96081,11.41679-32.09338C255.849,624.41024,238.35482,627.28542,227.632,638.72175Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.17176,642.56568c-2.7388,18.207-19.22943,29.92875-19.22943,29.92875S202.89214,654.6969,205.63092,636.49s19.22942-29.92876,19.22942-29.92876S236.91055,624.3587,234.17176,642.56568Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#f0f0f0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ed526203-2362-4a43-96ca-450f4725da7a",
    "data-name": "Rectangle 62",
    x: 307.75354,
    y: 14.50402,
    width: 529.04134,
    height: 251.03929,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "bc241c52-ebb2-41fa-9574-d106f872c1dd",
    "data-name": "Rectangle 75",
    x: 322.88165,
    y: 36.03108,
    width: 498.78585,
    height: 209.44993,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "bf2b7fee-aafd-4163-88e6-719b489e53a8",
    "data-name": "Rectangle 80",
    x: 307.52796,
    width: 529.04134,
    height: 22.47525,
    fill: "#e02365"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "bcccbf37-d4b5-4127-83d7-1cbb700c027e",
    "data-name": "Ellipse 90",
    cx: 324.22986,
    cy: 10.39584,
    r: 4.1657,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "a113f3b2-577f-43f8-9adc-c82fb7c016a2",
    "data-name": "Ellipse 91",
    cx: 340.0415,
    cy: 10.39584,
    r: 4.1657,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "b270d923-4b8c-4c85-892d-857a2ab12939",
    "data-name": "Ellipse 92",
    cx: 355.85387,
    cy: 10.39584,
    r: 4.1657,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 405.63899,
    y: 119.55589,
    width: 105.75586,
    height: 90.07694,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M693.30484,436.1686H586.93412V345.4768H693.30484ZM587.549,435.55374H692.69V346.09166H587.549Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 445.29743,
    y: 137.07939,
    width: 26.43896,
    height: 72.55344,
    fill: "#e02365"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 445.29743,
    y: 137.07939,
    width: 26.43896,
    height: 72.55344,
    fill: "#e02365"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "405.946 126.166 405.946 140.78 511.395 147.532 511.084 129.499 405.946 126.166",
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 399.49039,
    y: 111.25528,
    width: 118.05305,
    height: 25.8241,
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M699.45343,363.61516H580.78552v-26.439H699.45343Zm-118.053-.61486H698.83857V337.79106H581.40038Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 445.29743,
    y: 108.79584,
    width: 26.43896,
    height: 27.97611,
    fill: "#e02365"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M637.2887,310.63155c6.97909,10.34551.40348,26.98478.40348,26.98478s-17.89095-.13411-24.87-10.47963-.40348-26.98478-.40348-26.98478S630.3096,300.286,637.2887,310.63155Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e02365"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M640.49082,310.63155c-6.97909,10.34551-.40348,26.98478-.40348,26.98478s17.89095-.13411,24.87-10.47963.40348-26.98478.40348-26.98478S647.46991,300.286,640.49082,310.63155Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e02365"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 440.07113,
    cy: 89.42777,
    r: 2.76687,
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.67234,
    cy: 117.40388,
    r: 2.76687,
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 456.67234,
    cy: 177.96755,
    r: 2.76687,
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.44944,
    cy: 99.57295,
    r: 1.84458,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 475.11813,
    cy: 83.89403,
    r: 1.84458,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.12836,
    cy: 127.24163,
    r: 1.84458,
    fill: "#3f3d56"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 452.06089,
    cy: 151.22116,
    r: 1.84458,
    fill: "#3f3d56"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 461.59121,
    cy: 159.52176,
    r: 1.84458,
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 459.43921,
    cy: 194.26133,
    r: 1.84458,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M917.25913,388.20408H760.32027a7.392,7.392,0,1,1,0-14.78409H917.25913a7.392,7.392,0,1,1,0,14.78409Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M866.652,362.90053H760.32027a7.392,7.392,0,1,1,0-14.78409H866.652a7.392,7.392,0,1,1,0,14.78409Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e4e4e4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M906.51044,436.1686c5.23615-4.56543,13.68348-8.87561,20.49164-11.39947-6.80816-2.52619-15.25549-6.83643-20.49164-11.4018l3.6905,10.20307H891.05439v2.3974h19.14648Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#3f3d56"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M408.62578,460.59942a8.45126,8.45126,0,0,0-12.50553,3.398l-19.29818-.74461-3.3128,11.61709,27.26754.66877a8.497,8.497,0,0,0,7.849-14.93925Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#ffb6b6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M393.12028,476.99162l-19.66992,2.47-2.49024.31-40.02,5.02s-12.27978-8.85-23.1997-18.2v-9.76a39.5003,39.5003,0,0,1,9.77-26.04c14.77978,7.17,25.10009,23.98,25.10009,23.98l25.58985,2.5,2.56006.25,15.8999,1.55Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e4e4e4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M311.35546,555.35942h37.00193c0,1.58546,40.448,2.8722,40.448,2.8722a14.77562,14.77562,0,0,1,2.424,2.29776,14.258,14.258,0,0,1,3.3322,9.19105v2.29776a14.3663,14.3663,0,0,1-14.361,14.361H311.35546a14.37351,14.37351,0,0,1-14.361-14.361v-2.29776A14.381,14.381,0,0,1,311.35546,555.35942Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 156.66054,
    y: 359.58034,
    width: 14.93545,
    height: 86.20813,
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M395.70713,671.49215c0,1.61372-22.63233.62423-50.55075.62423s-50.55075.98956-50.55075-.62423,22.63234-14.41079,50.55075-14.41079S395.70713,669.87836,395.70713,671.49215Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "224.138 435.413 235.253 435.413 240.541 392.539 224.136 392.539 224.138 435.413",
    fill: "#ffb6b6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M402.90464,658.01268l21.8906-.00089h.00089A13.95118,13.95118,0,0,1,438.74654,671.962v.45333l-35.84124.00133Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.99 435.413 268.106 435.413 273.394 392.539 256.989 392.539 256.99 435.413",
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M435.75759,658.01268l21.89061-.00089h.00088A13.95116,13.95116,0,0,1,471.59949,671.962v.45333l-35.84123.00133Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#2f2e41"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 163.7177,
    cy: 169.25445,
    r: 19.32689,
    fill: "#ffb6b6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M347.50007,386.265s6.87447-9.55585,13.2779.0042,12.73607-2.03675,11.26476-5.6796-1.08368-4.08188-11.751-8.81259-31.17533-14.24354-37.17593,9.36546,6.27757,24.055,6.27757,24.055,2.50512-22.94146,5.39633-16.48242l2.8912,6.459,2.9704,1.06007Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M307.74208,527.90315s-6.48479,34.29038,18.18867,38.657,60.2902,7.4356,60.2902,7.4356l15.99432,74.62332,21.488-1.91839s-2.85783-89.82981-9.88578-96.85777-51.44725-28.07128-51.44725-28.07128Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M355.931,513.53181l10.791,10.82555s77.91729,12.5504,80.92315,30.54672c4.53813,27.17016,9.89839,86.25357,9.89839,86.25357l-23.42653-1.757-9.1865-67.16187L387.448,563.71271l-42.6446-23.24039Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M365.37028,522.77165s-60.18994,23.58-58.87012,9.71c1.53027-16.07,1.24024-23.07,1.24024-23.07v-52.58a39.62163,39.62163,0,0,1,21-34.96l20.31982.34,6.27,8.31c5.04,25.25,6.04,28.25,6.04,28.25l4.20019,11.5.87989,7.19-3.08008,15.31Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e4e4e4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M414.79778,460.6556l-.11824-.03675,1.9764-6.35835c.63175-2.03244.30461-3.94095-.7307-4.26276h0l-6.86195-2.13293c-1.0353-.32183-2.38672,1.06492-3.01848,3.09738h0l-10.84268,34.88249c-.63176,2.03246-.30464,3.941.73067,4.26277h0l6.862,2.13294c1.03531.32181,2.38672-1.0649,3.01848-3.09736l0,0,7.45945-23.99815.11824.03675Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e02365"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M415.79778,461.6556l-.11824-.03675,1.9764-6.35835c.63175-2.03244.30461-3.94095-.7307-4.26276h0l-6.86195-2.13293c-1.0353-.32183-2.38672,1.06492-3.01848,3.09738h0l-10.84268,34.88249c-.63176,2.03246-.30464,3.941.73067,4.26277h0l6.862,2.13294c1.03531.32181,2.38672-1.0649,3.01848-3.09736l0,0,7.45945-23.99815.11824.03675Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.18524,
    cy: 460.7855,
    rx: 2.36056,
    ry: 1.20244,
    transform: "translate(-333.18953 489.48301) rotate(-72.73295)",
    fill: "#d0cde1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M412.9959,475.59942a8.45122,8.45122,0,0,0-12.50553,3.398l-19.29818-.74461-3.3128,11.61709,27.26754.66877a8.497,8.497,0,0,0,7.849-14.93925Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#ffb6b6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M397.4904,491.99162l-22.16016,2.78-40.02,5.02s-15.87012-11.44-27.56982-22.05v-20.91a39.53793,39.53793,0,0,1,2.62988-14.19c20.64014,1.13,36.60986,27.13,36.60986,27.13l25.59033,2.5,18.46,1.8Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#e4e4e4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M563.60256,673.77165h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z",
    transform: "translate(-181.60256 -226.22835)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSendGiftJl1Z);
export default __webpack_public_path__ + "static/media/undraw_send-gift_jl1z.d65d7cc010f5ea89b1c370d44fa10e92.svg";
export { ForwardRef as ReactComponent };